import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';

import { BaseIcon, BaseStatus } from 'bxcommon';
import { STATUS } from 'bxcommon/constants/status.constant';
import ListViewWrapper from 'bxcommon/components/ListViewWrapper/ListViewWrapper';
import { RequestContext } from 'bxcommon/context/Request.context';
import { useRequestList } from 'bxcommon/context/RequestList.context';
import { api } from 'bxcommon/store/api';

import {
  ADVISOR_PAGE_SIZE,
  useGetAdvisorListQuery,
  useLazyGetAdvisorListQuery,
} from '../../store/endpoints/registry.endpoints';
import { AdvisorHeader } from '../AdvisorHeader/AdvisorHeader';

const removeFromAdvisorList = (caseId) => async (dispatch) => {
  await dispatch(api.endpoints.deleteAdvisor.initiate(caseId));
};

const ListView = () => {
  const labels = ['lastUpdate', 'caseId', 'name', 'status', 'public', ''];

  const navigate = useNavigate();

  const { list, count, page, setPage } = useRequestList();

  // Refetch the current page every time the page is mounted (incl. nav back).
  useGetAdvisorListQuery({ page }, { refetchOnMountOrArgChange: true });
  const [triggerSearch] = useLazyGetAdvisorListQuery();

  const hydrateAdvisorList = (search, query) => async () => {
    const result = await triggerSearch(search ? { search, query } : { page });
    return result.data?.results ?? [];
  };

  const isAdmin = useSelector((state) => state.user.details.is_admin);

  const { clearForm, request } = useContext(RequestContext);

  useEffect(() => {
    if (!isAdmin) {
      navigate('/');
    }
  }, [isAdmin, navigate]);

  useEffect(() => {
    if (list.length && request.case_id) {
      clearForm();
    }
  }, [clearForm, list, request]);

  return (
    <AdvisorHeader>
      <ListViewWrapper
        labels={labels}
        editUrl={'request-form'}
        search={{ queryName: 'query', hydrateList: hydrateAdvisorList, placeholder: 'list.searchPlaceholder' }}
        detailsUrl={'request-details'}
        removeFromList={removeFromAdvisorList}
        selectable
      >
        {(item) => (
          <>
            <td className="copy copy--color-dark" data-testid="list-name">
              {item.first_name} {item.last_name}
            </td>
            <td className="copy copy--color-dark" data-testid="list-status">
              <BaseStatus status={item.status} />
            </td>
            <td className="copy copy--color-dark" data-testid="list-published">
              {item.status === STATUS.APPROVED && (
                <BaseIcon
                  icon={item.is_published ? 'yes' : 'no'}
                  data-testid={item.is_published ? 'public' : 'not-public'}
                />
              )}
            </td>
          </>
        )}
      </ListViewWrapper>
      {count > ADVISOR_PAGE_SIZE && (
        <div className="container" style={{ display: 'flex', justifyContent: 'center', paddingBottom: 24 }}>
          <Pagination
            current={page}
            total={count}
            pageSize={ADVISOR_PAGE_SIZE}
            showSizeChanger={false}
            onChange={setPage}
          />
        </div>
      )}
    </AdvisorHeader>
  );
};

export default ListView;
